const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        hostpital: 'Lindenhofgruppe',
        impressum: 'Impressum',
        surgeryCardHintText:
            'Bis 6h vor Eintritt ist Essen erlaubt{br}Bis 2h vor Eintritt sind klare Flüssigkeiten (Wasser ohne Kohlensäure, Sirup, Tee, schwarzer Kaffee - OHNE MILCH) erlaubt',
        surgeryCardHintTitle:
            'Wichtige Informationen zu Nüchternzeiten vor der Operation, wenn der Eintritt ins Spital am gleichen Tag der Operation erfolgt',
        surgeryCardContactAlertText:
            'Für eine telefonische Vorbesprechung versucht Sie die Anästhesistin/der Anästhesist am Vortag zu erreichen.',
        surgeryCardContactAlertTitle: 'Telefonische Vorbesprechung',
        navbarTitle: 'Patientenportal',
        welcomeText:
            'Mit dem Patientenportal erhalten Patientinnen und Patienten der Lindenhofgruppe eine Übersicht über Ihre Spitaltermine und haben jederzeit Zugriff auf alle wichtigen Informationen rund um Ihre Gesundheit.',
    },
    __RELATIVE_SOURCE_FILE__
);
